
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaitoashtavinayakcab() {



const cardData = {
  keyword: "Navi Mumbai to Ashtavinayak Cab Service",
  heading: "Skyline Cabs: Navi Mumbai to Ashtavinayak Cab Service",
  headingDescription: "Skyline Cabs offers dedicated Navi Mumbai to Ashtavinayak Cab Service for comfortable, well-planned, and spiritually fulfilling pilgrimage journeys across Maharashtra. The Ashtavinayak Yatra covers eight sacred Lord Ganesha temples located in different towns including Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon. Our professional drivers are familiar with the traditional temple sequence and road routes, ensuring a smooth and organized darshan experience. Whether you require a one-day express darshan trip or a relaxed two-day spiritual tour, we provide clean vehicles, flexible schedules, and transparent pricing. Travel peacefully with Skyline Cabs and complete your Ashtavinayak Yatra comfortably.",

  top: "Top Ashtavinayak Temples to Visit from Navi Mumbai",

  topPlaces: [
    {
      title: "Moreshwar Temple – Morgaon",
      description: "Moreshwar Temple in Morgaon is considered the starting point of the Ashtavinayak Yatra and holds immense spiritual importance. Devotees believe Lord Ganesha resides here in a self-manifested form, attracting thousands of pilgrims annually. The temple’s stone architecture, spacious courtyard, and peaceful rural surroundings create a divine atmosphere ideal for prayer and meditation. Travelers booking Navi Mumbai to Ashtavinayak Cab often begin their journey here to follow the traditional sequence. Early morning darshan is recommended for a peaceful experience. Skyline Cabs ensures comfortable highway travel from Navi Mumbai to Morgaon with planned rest stops and flexible timing."
    },
    {
      title: "Siddhivinayak Temple – Siddhatek",
      description: "Siddhatek Temple is located on the banks of the Bhima River and is believed to grant spiritual fulfillment and blessings. The temple requires a small pradakshina around the hill, which adds to the devotional experience. Pilgrims choosing Ashtavinayak Cab Service from Navi Mumbai appreciate comfortable travel arrangements for this slightly remote location. The calm riverside setting enhances spiritual concentration."
    },
    {
      title: "Ballaleshwar Temple – Pali",
      description: "Ballaleshwar Temple in Pali is unique as it is the only Ashtavinayak temple named after a devotee, Ballal. The temple architecture features traditional wooden carvings and stone design. Many families booking Navi Mumbai Ashtavinayak Darshan Cab include Pali in their itinerary for peaceful darshan."
    },
    {
      title: "Varadvinayak Temple – Mahad",
      description: "Varadvinayak Temple at Mahad is known for granting wishes and blessings. Devotees can personally enter the sanctum and offer prayers, making it a special spiritual experience. Navi Mumbai to Ashtavinayak Taxi Service ensures smooth connectivity to this sacred site."
    },
    {
      title: "Chintamani Temple – Theur",
      description: "Chintamani Temple in Theur symbolizes removal of worries and obstacles. The temple is surrounded by greenery and peaceful environment. Travelers booking Ashtavinayak Taxi Booking Navi Mumbai often schedule extended prayer time here."
    },
    {
      title: "Girijatmaj Temple – Lenyadri",
      description: "Located inside a mountain cave, Girijatmaj Temple requires climbing several steps, offering both spiritual and physical dedication. Navi Mumbai to Ashtavinayak Cab ensures comfortable journey before the climb."
    },
    {
      title: "Vighnahar Temple – Ozar",
      description: "Vighnahar Temple is believed to remove life’s obstacles. Its golden dome and spacious temple complex attract pilgrims year-round."
    },
    {
      title: "Mahaganapati Temple – Ranjangaon",
      description: "Mahaganapati Temple in Ranjangaon marks the completion of the Ashtavinayak Yatra. Devotees conclude their pilgrimage here before returning to Navi Mumbai comfortably with Skyline Cabs."
    }
  ],

  services: [
    {
      name: "Navi Mumbai to Ashtavinayak Cab",
      description: "Skyline Cabs provides reliable Navi Mumbai to Ashtavinayak Cab service designed for spiritual comfort and organized temple travel. Our drivers are experienced with the traditional Ashtavinayak temple route sequence, ensuring smooth intercity travel between all eight temples. Vehicles are well-maintained, air-conditioned, and spacious enough for family pilgrimage groups. Flexible scheduling allows devotees to spend adequate time at each temple without rush. Whether planning a single-day express darshan or extended two-day yatra, we offer customized packages with transparent pricing and professional travel coordination."
    },
    {
      name: "Navi Mumbai Ashtavinayak Darshan Cab",
      description: "Our Navi Mumbai Ashtavinayak Darshan Cab ensures a peaceful pilgrimage experience with planned temple sequencing and comfortable highway travel. Families, senior citizens, and group travelers benefit from smooth suspension vehicles and experienced chauffeurs familiar with rural temple roads."
    },
    {
      name: "Ashtavinayak Cab Service from Navi Mumbai",
      description: "Ashtavinayak Cab Service from Navi Mumbai includes full-day and multi-day pilgrimage packages covering all eight sacred temples. Skyline Cabs ensures flexible timing, safe driving, and devotional convenience."
    },
    {
      name: "Navi Mumbai to Ashtavinayak Taxi",
      description: "Book Navi Mumbai to Ashtavinayak Taxi for economical and comfortable temple travel with professional chauffeurs and clear fare structure."
    },
    {
      name: "Ashtavinayak Yatra Cab from Navi Mumbai",
      description: "Ashtavinayak Yatra Cab from Navi Mumbai offers structured pilgrimage routes with temple sequencing guidance and flexible travel breaks."
    },
    {
      name: "Navi Mumbai to Ashtavinayak Taxi Service",
      description: "Navi Mumbai to Ashtavinayak Taxi Service ensures smooth rural connectivity, safe travel, and comfortable seating for long-distance pilgrimage."
    },
    {
      name: "Ashtavinayak Taxi Booking Navi Mumbai",
      description: "Ashtavinayak Taxi Booking Navi Mumbai allows easy online reservations with transparent pricing and confirmed vehicle allocation."
    }
  ],

  tableData: [
    ["Navi Mumbai to Ashtavinayak Cab", "Navi Mumbai Ashtavinayak Darshan Cab"],
    ["Ashtavinayak Cab Service from Navi Mumbai", "Navi Mumbai to Ashtavinayak Taxi"],
    ["Ashtavinayak Yatra Cab from Navi Mumbai", "Navi Mumbai to Ashtavinayak Taxi Service"],
    ["Ashtavinayak Taxi Booking Navi Mumbai", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Temple Route Expertise",
      WhyChoosedescription: "Our drivers understand the traditional Ashtavinayak temple sequence ensuring smooth and organized pilgrimage travel."
    },
    {
      WhyChooseheading: "Comfortable Long-Distance Vehicles",
      WhyChoosedescription: "Spacious, air-conditioned cars suitable for elderly devotees and families."
    },
    {
      WhyChooseheading: "Flexible Darshan Timing",
      WhyChoosedescription: "Devotees can spend sufficient prayer time at each temple without schedule pressure."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription: "Clear fare breakdown with no hidden charges."
    },
    {
      WhyChooseheading: "Safe & Professional Drivers",
      WhyChoosedescription: "Experienced chauffeurs familiar with rural temple roads."
    },
    {
      WhyChooseheading: "Multi-Day Packages Available",
      WhyChoosedescription: "Flexible 1-day and 2-day Ashtavinayak travel packages."
    },
    {
      WhyChooseheading: "24x7 Booking Support",
      WhyChoosedescription: "Round-the-clock assistance for pilgrimage planning."
    },
    {
      WhyChooseheading: "Customer-Centric Service",
      WhyChoosedescription: "Dedicated support team ensures smooth spiritual travel experience."
    }
  ]
}


const faqData = [
    {
        id: 1,
        question: 'How can I book Navi Mumbai to Ashtavinayak Cab Service with Skyline Cabs?',
        answer:
            'Booking Navi Mumbai to Ashtavinayak Cab Service with Skyline Cabs is simple and convenient. Visit our website or mobile app, enter Navi Mumbai as your pickup location and select the Ashtavinayak temple circuit as your destination. Choose your preferred vehicle and confirm instantly. You will receive booking confirmation along with driver details for a smooth and well-planned pilgrimage journey.',
    },
    {
        id: 2,
        question: 'What is included in Navi Mumbai to Ashtavinayak Cab Service package?',
        answer:
            'Our Navi Mumbai to Ashtavinayak Cab Service package includes comfortable transportation to all eight Ashtavinayak temples, professional chauffeur service, and transparent pricing. The package can be customized based on your travel schedule, temple visit order, and number of days. We ensure a safe and peaceful travel experience throughout the pilgrimage.',
    },
    {
        id: 3,
        question: 'Which vehicles are available for Navi Mumbai to Ashtavinayak Cab Service?',
        answer:
            'Skyline Cabs offers multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Navi Mumbai to Ashtavinayak Cab Service. For families and groups, spacious vehicles with ample luggage space are recommended to ensure comfortable long-distance travel.',
    },
    {
        id: 4,
        question: 'Is the fare for Navi Mumbai to Ashtavinayak Cab Service fixed?',
        answer:
            'Yes, Skyline Cabs provides transparent and fixed pricing for Navi Mumbai to Ashtavinayak Cab Service. The fare is shared before booking confirmation and includes driver allowance and applicable charges. There are no hidden fees, ensuring complete clarity in pricing.',
    },
    {
        id: 5,
        question: 'How long does the Navi Mumbai to Ashtavinayak trip take?',
        answer:
            'The Navi Mumbai to Ashtavinayak pilgrimage typically takes 2 to 3 days depending on your travel plan and temple visit sequence. The total journey covers multiple temple locations across Maharashtra. Our drivers ensure smooth highway travel and proper time management during temple visits.',
    },
    {
        id: 6,
        question: 'Can I customize my Navi Mumbai to Ashtavinayak Cab Service itinerary?',
        answer:
            'Yes, Skyline Cabs allows full customization of your Navi Mumbai to Ashtavinayak Cab Service itinerary. You can choose temple visit order, overnight stay options, and return schedule according to your convenience. Our flexible travel planning ensures a comfortable and spiritual journey.',
    },
    {
        id: 7,
        question: 'Is online payment available for Navi Mumbai to Ashtavinayak Cab booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments via UPI, credit cards, debit cards, and net banking. Once payment is completed, you receive instant confirmation along with trip and driver details.',
    },
    {
        id: 8,
        question: 'Is Navi Mumbai to Ashtavinayak Cab Service suitable for family pilgrimage?',
        answer:
            'Absolutely. Our Navi Mumbai to Ashtavinayak Cab Service is ideal for families and senior citizens. We provide comfortable seating, smooth suspension vehicles, experienced drivers, and flexible stop options to ensure a relaxed pilgrimage experience.',
    },
    {
        id: 9,
        question: 'Is Navi Mumbai to Ashtavinayak Cab Service available year-round?',
        answer:
            'Yes, Skyline Cabs offers Navi Mumbai to Ashtavinayak Cab Service throughout the year. Whether you plan your pilgrimage during festivals, weekends, or regular days, we ensure reliable and safe transportation.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai to Ashtavinayak Cab Service?',
        answer:
            'Skyline Cabs is trusted for Navi Mumbai to Ashtavinayak Cab Service because of our experienced chauffeurs, comfortable vehicles, transparent pricing, punctual service, and 24x7 customer support. We focus on delivering a peaceful, safe, and well-managed pilgrimage travel experience for every devotee.',
    },
];

const someReviews = [
    {
        name: "Mr. Vinay Joshi",
        rating: 5,
        review: "Booked Navi Mumbai to Ashtavinayak Cab Service with Skyline Cabs for family pilgrimage. The driver was very cooperative, the car was comfortable, and the entire trip was smooth and well-managed. Highly recommended service!"
    },
    {
        name: "Mrs. Anjali Deshmukh",
        rating: 4,
        review: "Very reliable Navi Mumbai to Ashtavinayak Cab Service. Transparent pricing, safe driving, and flexible temple visit schedule. Skyline Cabs made our spiritual journey comfortable and stress-free."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Ashtavinayak Cab Service",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-to-ashtavinayak-cab.jpg",
  "description": "Book Navi Mumbai to Ashtavinayak Cab Service with Skyline Cabs for a comfortable and safe Yatra trip. AC cabs available for one way and round trip travel with professional drivers ensuring timely pickup and drop.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-to-ashtavinayak-cab-service"
  }
};




    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Ashtavinayak Cab Service | AC Cab & Yatra Trip | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to Ashtavinayak Cab Service with Skyline Cabs for a safe and comfortable Yatra trip. AC cabs available for one way and round trip with professional drivers ensuring timely pickup and drop." 
  />
  <meta 
    name="keywords" 
    content="Navi Mumbai to Ashtavinayak Cab, Navi Mumbai Ashtavinayak Darshan Cab, Ashtavinayak Cab Service from Navi Mumbai, Navi Mumbai to Ashtavinayak Taxi, Ashtavinayak Yatra Cab from Navi Mumbai, Navi Mumbai to Ashtavinayak Taxi Service, Ashtavinayak Taxi Booking Navi Mumbai, AC Cab for Ashtavinayak from Navi Mumbai, Round Trip Cab Navi Mumbai to Ashtavinayak, Skyline Cabs Navi Mumbai to Ashtavinayak" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/131.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitoashtavinayakcab;